export { default } from './diagnostic-cog-icon.container';
